<template>
  <section
    id="showcase"
    class="showcase-section"
  >
    <div class="showcase-container">
      <!-- Section Header -->
      <div class="section-header">
        <span class="section-badge">
          <i class="fas fa-images" />
          Campus Life
        </span>
        <h2 class="section-title">
          Experience <span class="highlight">NC</span>
        </h2>
        <p class="section-subtitle">
          Discover the vibrant student life and modern facilities at Northeastern College
        </p>
      </div>

      <!-- Image Grid -->
      <div class="showcase-grid">
        <!-- Main Image -->
        <div class="showcase-card showcase-large">
          <div class="showcase-image">
            <template v-if="videoLoaded">
              <iframe
                class="iframe-container"
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/LZUUCoeJqPE?si=GuNudrPxtjnqSpKX&autoplay=1"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
                loading="lazy"
              />
            </template>
            <template v-else>
              <img
                src="@/assets/images/nccampus.png"
                alt="Our Campus Video"
                class="video-facade"
              >
              <button
                class="play-btn"
                aria-label="Play campus video"
                @click="videoLoaded = true"
              >
                <svg
                  width="64"
                  height="64"
                  viewBox="0 0 64 64"
                  fill="none"
                ><circle
                  cx="32"
                  cy="32"
                  r="32"
                  fill="rgba(0,0,0,0.6)"
                /><polygon
                  points="26,20 26,44 46,32"
                  fill="#fff"
                /></svg>
              </button>
            </template>
          </div>
          <div
            v-if="!videoLoaded"
            class="showcase-overlay"
          >
            <h3>Our Campus</h3>
            <p>Modern facilities designed for academic excellence</p>
          </div>
        </div>

        <!-- Small Cards -->
        <div class="showcase-card">
          <div class="showcase-image">
            <img
              src="@/assets/images/nccampus.png"
              alt="Student Activities"
              loading="lazy"
            >
          </div>
          <div class="showcase-overlay">
            <h4>Student Organizations</h4>
          </div>
        </div>

        <div class="showcase-card">
          <div class="showcase-image">
            <img
              src="@/assets/images/nccampus.png"
              alt="Library"
              loading="lazy"
            >
          </div>
          <div class="showcase-overlay">
            <h4>Learning Resources</h4>
          </div>
        </div>

        <div class="showcase-card">
          <div class="showcase-image">
            <img
              src="@/assets/images/nccampus.png"
              alt="Computer Labs"
              loading="lazy"
            >
          </div>
          <div class="showcase-overlay">
            <h4>Tech Facilities</h4>
          </div>
        </div>

        <div class="showcase-card">
          <div class="showcase-image">
            <img
              src="@/assets/images/nccampus.png"
              alt="Sports"
              loading="lazy"
            >
          </div>
          <div class="showcase-overlay">
            <h4>Athletics &amp; Sports</h4>
          </div>
        </div>
      </div>

      <!-- Stats Bar -->
      <div class="stats-bar">
        <div class="stat-item">
          <div class="stat-value">
            5,000+
          </div>
          <div class="stat-label">
            Students
          </div>
        </div>
        <div class="stat-divider" />
        <div class="stat-item">
          <div class="stat-value">
            50+
          </div>
          <div class="stat-label">
            Programs
          </div>
        </div>
        <div class="stat-divider" />
        <div class="stat-item">
          <div class="stat-value">
            200+
          </div>
          <div class="stat-label">
            Faculty
          </div>
        </div>
        <div class="stat-divider" />
        <div class="stat-item">
          <div class="stat-value">
            30+
          </div>
          <div class="stat-label">
            Years of Excellence
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import '@/assets/css/landing/sections/showcase.css'

export default {
  name: 'ShowcaseSection',
  data () {
    return {
      videoLoaded: false
    }
  }
}
</script>

<style scoped>
.video-facade {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.play-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: none;
  border: none;
  cursor: pointer;
  z-index: 2;
  padding: 0;
  transition: transform 0.2s;
}

.play-btn:hover {
  transform: translate(-50%, -50%) scale(1.1);
}
</style>
